// 템플릿별 필드 레이블 매핑
// 새 템플릿 추가 시 여기에 추가

export const FIELD_LABELS = {
  residential: {
    room_no:          '호수',
    room_no_ph:       '호수 (예: 201)',
    user_name:        '이름',
    user_name_ph:     '입주자 이름',
    phone:            '전화번호',
    phone_ph:         '전화번호 (예: 01012345678)',
    expires_at:       '만료일',
    select_ph:        '호수를 선택하세요',
    add_btn:          '➕ 신규 입주자',
    required_msg:     '호수, 이름, 전화번호는 필수입니다.',
    not_found_msg:    '등록 정보가 없습니다.\n이름과 전화번호를 다시 확인해주세요.',
    main_door:        '1층 공동현관',
    door_select:      '열릴 문 선택',
    room_suffix:      '호',
    unit_door:        '세대문',
    delete_confirm:   '퇴거',
    activate_confirm: '활성',
  },
  parking: {
    room_no:          '주차면',
    room_no_ph:       '주차면 (예: P01)',
    user_name:        '차량번호',
    user_name_ph:     '차량번호 (예: 12가 3456)',
    phone:            '연락처',
    phone_ph:         '연락처 (예: 01012345678)',
    expires_at:       '이용 만료일',
    select_ph:        '주차면을 선택하세요',
    add_btn:          '➕ 신규 차량 등록',
    required_msg:     '주차면, 차량번호, 연락처는 필수입니다.',
    not_found_msg:    '등록 정보가 없습니다.\n차량번호와 연락처를 다시 확인해주세요.',
    main_door:        '차량 출입구',
    door_select:      '열릴 게이트 선택',
    room_suffix:      '',
    unit_door:        '주차구역',
    delete_confirm:   '차량 해제',
    activate_confirm: '차량 등록',
  },
  storage: {
    room_no:          '창고번호',
    room_no_ph:       '창고번호 (예: S01)',
    user_name:        '고객명',
    user_name_ph:     '고객명',
    phone:            '연락처',
    phone_ph:         '연락처 (예: 01012345678)',
    expires_at:       '계약 만료일',
    select_ph:        '창고번호를 선택하세요',
    add_btn:          '➕ 신규 고객 등록',
    required_msg:     '창고번호, 고객명, 연락처는 필수입니다.',
    not_found_msg:    '등록 정보가 없습니다.\n고객명과 연락처를 다시 확인해주세요.',
    main_door:        '창고 출입구',
    door_select:      '열릴 문 선택',
    room_suffix:      '',
    unit_door:        '창고',
    delete_confirm:   '계약 해지',
    activate_confirm: '계약 활성',
  },
  store: {
    room_no:          '회원번호',
    room_no_ph:       '회원번호 (예: M001)',
    user_name:        '회원명',
    user_name_ph:     '회원명',
    phone:            '연락처',
    phone_ph:         '연락처 (예: 01012345678)',
    expires_at:       '만료일',
    select_ph:        '회원을 선택하세요',
    add_btn:          '➕ 신규 회원 등록',
    required_msg:     '회원번호, 회원명, 연락처는 필수입니다.',
    not_found_msg:    '등록 정보가 없습니다.\n회원명과 연락처를 다시 확인해주세요.',
    main_door:        '상점 출입구',
    door_select:      '열릴 문 선택',
    room_suffix:      '',
    unit_door:        '출입문',
    delete_confirm:   '회원 탈퇴',
    activate_confirm: '회원 활성',
  },
};

export function getLabels(template) {
  return FIELD_LABELS[template] || FIELD_LABELS['residential'];
}
